import styled from 'styled-components'
import { color } from 'utils/functions/colors'

export const EmptyStateContainer = styled.div`
  border: 0.1rem ${color('veryLightBlue')} dashed;
  display: flex;
  justify-content: center;
  padding: 1.6rem;
`
